import { CircleCheck, TriangleAlert, OctagonX } from "lucide-react";

export const STATUS_META = {
  AUTORISEE: {
    label: "EXPLOITATION AUTORISÉE", short: "AUTORISÉ", emoji: "🟢", icon: CircleCheck,
    badge: "bg-emerald-500/15 text-emerald-300 border-emerald-500/50",
    dot: "bg-emerald-500", border: "border-emerald-500/60",
    glow: "shadow-[0_0_24px_-4px_rgba(34,197,94,0.55)]", solidBg: "bg-emerald-950/70",
  },
  RESERVES: {
    label: "AUTORISÉ AVEC RÉSERVES", short: "RÉSERVES", emoji: "🟠", icon: TriangleAlert,
    badge: "bg-amber-500/15 text-amber-300 border-amber-500/50",
    dot: "bg-amber-500", border: "border-amber-500/60",
    glow: "shadow-[0_0_24px_-4px_rgba(245,158,11,0.55)]", solidBg: "bg-amber-950/70",
  },
  SUSPENDUE: {
    label: "EXPLOITATION SUSPENDUE", short: "SUSPENDU", emoji: "🔴", icon: OctagonX,
    badge: "bg-red-500/20 text-red-300 border-red-500/60",
    dot: "bg-red-600", border: "border-red-600/70",
    glow: "shadow-[0_0_28px_-2px_rgba(220,38,38,0.65)]", solidBg: "bg-red-950/80",
  },
};

export const StatusBadge = ({ status, testId, className = "" }) => {
  const meta = STATUS_META[status] || STATUS_META.AUTORISEE;
  const Icon = meta.icon;
  return (
    <span
      data-testid={testId}
      className={`inline-flex items-center gap-2 rounded-full border px-3 py-1.5 font-bold uppercase tracking-wide text-xs whitespace-nowrap ${meta.badge} ${className}`}
    >
      <Icon className="w-4 h-4 shrink-0" /> {meta.label}
    </span>
  );
};

export const statusLabel = (status) => (STATUS_META[status] || STATUS_META.AUTORISEE).label;
export const statusEmoji = (status) => (STATUS_META[status] || STATUS_META.AUTORISEE).emoji;
